{
    "Presence_Page_Title": "Presença",
    "Presence_SortBy_Title": "Ordenar por:",
    "Presence_SortBy_Options_FullName_ASC": "Nome completo (A-Z)",
    "Presence_SortBy_Options_FullName_DSC": "Nome completo (Z-A)",
    "Presence_Search_Title": "Pesquisar",
    "Presence_Filter_Title": "Mais filtros",
    "Presence_MoreFilters_Title": "Filtrar por:",
    "Presence_MoreFilters_Options_Department": "Departamento",
    "Presence_MoreFilters_Options_Queue": "Fila de espera",
    "Presence_Filter_Availability_All": "Todos",
    "Presence_Filter_Availability_Available": "Disponível",
    "Presence_Filter_Availability_Busy": "Ocupado",
    "Presence_Filter_Availability_Away": "Fora",
    "Presence_Filter_Availability_Offline": "Fora de linha",
    "Presence_Filter_Availability_OutOfOffice": "Fora do escritório",
    "Presence_Filter_Availability_DoNotDisturb": "Não incomodar",
    "Presence_Filter_Availability_BeRightBack": "Volto já",
    "Presence_Activity_Available_Title": "Disponível",
    "Presence_Activity_Away_Title": "Fora",
    "Presence_Activity_BeRightBack_Title": "Volto já",
    "Presence_Activity_Busy_Title": "Ocupado",
    "Presence_Activity_DoNotDisturb_Title": "Não incomodar",
    "Presence_Activity_InAcall_Title": "Numa chamada",
    "Presence_Activity_InAConferenceCall_Title": "Numa chamada em conferência",
    "Presence_Activity_Inactive_Title": "Inativo",
    "Presence_Activity_InAMeeting_Title": "Numa reunião",
    "Presence_Activity_Offline_Title": "Fora de linha",
    "Presence_Activity_OffWork_Title": "Fora do trabalho",
    "Presence_Activity_OutOfOffice_Title": "Fora do escritório",
    "Presence_Activity_PresenceUnknown_Title": "Presença Desconhecida",
    "Presence_Activity_Presenting_Title": "Apresentação",
    "Presence_Activity_UrgentInterruptionsOnly_Title": "Apenas interrupções urgentes",
    "Presence_NoUsers": "Não existem utilizadores disponíveis para o seu filtro atual",
    "NAME": "Presence",
    "Presence_Activity_InACall_Title": "Numa chamada",
    "Presence_SearchQuery_TooLong": "A pesquisa é demasiado longa"
}